import { render } from "./TarotDetailPage.vue?vue&type=template&id=42f31616&scoped=true"
import script from "./TarotDetailPage.vue?vue&type=script&lang=js"
export * from "./TarotDetailPage.vue?vue&type=script&lang=js"

import "./TarotDetailPage.vue?vue&type=style&index=0&id=42f31616&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f31616"]])

export default __exports__